import { api } from './client';

export type OnboardingStepName = 'PERSONAL_INFO' | 'EMERGENCY_CONTACTS' | 'PDPA_CONSENT';
export type OnboardingStepStatus = 'PENDING' | 'COMPLETED' | 'SKIPPED';

export interface OnboardingStepState {
  step: OnboardingStepName;
  status: OnboardingStepStatus;
  completedAt: string | null;
}

export interface PersonalInfoPayload {
  phoneNumber?: string;
  address1?: string;
  address2?: string;
  city?: string;
  postcode?: string;
  state?: string;
  maritalStatus?: string;
}

export interface EmergencyContactPayload {
  fullName: string;
  relationship: 'SPOUSE' | 'PARENT' | 'SIBLING' | 'CHILD' | 'FRIEND' | 'OTHER';
  phoneNumber: string;
  email?: string;
}

export interface EmergencyContactsPayload {
  contacts: EmergencyContactPayload[];
  spouse?: { fullName: string; phoneNumber?: string; occupationStatus?: string };
  dependents?: Array<{ fullName: string; dateOfBirth: string; gender: 'M' | 'F'; relationshipType?: string }>;
}

export interface OnboardingState {
  steps: OnboardingStepState[];
  prefill: {
    personalInfo: PersonalInfoPayload;
    emergencyContacts: Array<{ id: string; fullName: string; relationship: string; phoneNumber: string; email: string | null }>;
    spouse: { id: string; fullName: string; phoneNumber: string | null; occupationStatus: string | null } | null;
    dependents: Array<{ id: string; fullName: string; dateOfBirth: string | null; gender: 'M' | 'F' | null; relationshipType: string | null }>;
    pdpaConsented: boolean;
  };
}

interface StepsResponse {
  message: string;
  steps: OnboardingStepState[];
}

export function getOnboarding() {
  return api<OnboardingState>('/onboarding');
}

export function savePersonalInfo(data: PersonalInfoPayload) {
  return api<StepsResponse>('/onboarding/personal-info', { method: 'POST', body: JSON.stringify(data) });
}

export function saveEmergencyContacts(data: EmergencyContactsPayload) {
  return api<StepsResponse>('/onboarding/emergency-contacts', { method: 'POST', body: JSON.stringify(data) });
}

export function recordPdpaConsent() {
  return api<StepsResponse>('/onboarding/pdpa-consent', { method: 'POST', body: JSON.stringify({ consented: true }) });
}

export function skipStep(step: OnboardingStepName) {
  return api<StepsResponse>(`/onboarding/steps/${step}/skip`, { method: 'POST' });
}
